import React from 'react';

interface IconDailyBriefingProps {
    iconClasses?: string;
}

/** Clipboard outline icon for Daily Briefing. */
const IconDailyBriefing: React.FC<IconDailyBriefingProps> = ({ iconClasses }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-daily-briefing ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <rect
                x="5"
                y="4"
                width="14"
                height="17"
                rx="2.5"
                stroke="currentColor"
                strokeWidth="1.75"
            />
            <rect
                x="8.5"
                y="2"
                width="7"
                height="3.5"
                rx="1.1"
                stroke="currentColor"
                strokeWidth="1.75"
            />
        </svg>
    );
};

export default IconDailyBriefing;
